<template>
  <div class="marketing-partners">

    <div class="partners-heading block-heading-font-style">Vetted for Excellence</div>
    <div class="partners-subheading block-subheading-font-style">MikMak is proud to announce that we have been named as a Marketing Partner by Facebook, Snapchat and Instagram.</div>

    <span class="partner-logos">
      <a href="https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak" target="new"><img src="../assets/fb-partners.png" class="partner-logo"></a>
      <img src="../assets/snapchat-partners.png" class="partner-logo snap-logo">
      <a href="https://www.facebook.com/business/solutions-explorer/community_management/278913029298091/MikMak" target="new"><img src="../assets/ig-partners.png" class="partner-logo"></a>
    </span>

  </div>
</template>

<script>

export default {
  mounted() {
    if (!window.sr) window.sr = ScrollReveal()
    window.sr.reveal('.marketing-partners', { delay: 250, duration: 500 })
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .marketing-partners {
    display: block;
    background: #ececec;
    padding: 24px 0;
  }

  .partner-logos {
    display: block;
    text-align: center;
    margin: 24px;
  }

  .partner-logo {
    display: inline-block;
    width: 200px;
    vertical-align: middle;
    margin: 24px 48px;
  }

  .snap-logo {
    width: 100px;
  }

</style>



// WEBPACK FOOTER //
// MarketingPartners.vue?a9470548